module.exports = __webpack_public_path__ + "img/status-change.0021b929.svg";